const expect = {
  state: {
    expectDate: ''
  },
  mutations: {
    SET_EXPECTDATE: (state, expectDate) => {
      state.expectDate = expectDate
    }
  },
  actions: {
    setExpectDate({ commit }, expectDate) {
      return new Promise((resolve, reject) => {
        commit('SET_EXPECTDATE', expectDate)
        resolve()
      })
    }
  }
}
export default expect



// WEBPACK FOOTER //
// ./src/store/modules/expect.js